import { NetworkStatus } from '@apollo/client';

import { normalizeChatUuid } from './notification-helpers';
import type { GetChatWithMessages } from '../../../queries/chats';

export function getCurrentChatWithMessages({
  chatUuid,
  isNewChat,
  chat,
}: {
  chatUuid?: string;
  isNewChat: boolean;
  chat?: GetChatWithMessages | null;
}): GetChatWithMessages | undefined {
  if (!chatUuid || isNewChat || !chat) {
    return undefined;
  }

  return chat.uuid === normalizeChatUuid(chatUuid) ? chat : undefined;
}

export function getIsMessagesLoading({
  chat,
  currentChat,
  isNewChat,
  networkStatus,
}: {
  chat?: GetChatWithMessages | null;
  currentChat?: GetChatWithMessages;
  isNewChat: boolean;
  networkStatus: NetworkStatus;
}): boolean {
  if (isNewChat || currentChat) {
    return false;
  }

  if (chat && !currentChat) {
    return true;
  }

  return (
    networkStatus === NetworkStatus.loading ||
    networkStatus === NetworkStatus.setVariables ||
    networkStatus === NetworkStatus.refetch
  );
}
